/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
import { Component } from 'react';
import { connect } from 'react-redux';
import { ItemView } from '..';
import './PreviousNext.scss';

/**

@Author Karthik

@param

@return Previous next handle html

**/

class PreviousNext extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleItemView: true
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match?.params?.itemId !== this.props.match?.params?.itemId) {
            this.setState({
                toggleItemView: !this.state.toggleItemView
            }, () => {
                setTimeout(() => {
                    this.reRender();
                }, 20)
            });
        }
    }

    reRender = () => {
        this.setState({
            toggleItemView: !this.state.toggleItemView
        });
    }

    render() {
        return (
            <div className="previous-next-main h-100">
                {
                    this.state.toggleItemView ?
                        <ItemView {...this.props}></ItemView> :
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div>
                }
            </div>
        );
    }

}

export default connect(state => state)(PreviousNext);